import { configure } from 'mobx';

import '@/common/report-rum';
import '@/common/report-beacon';

configure({
  useProxies: 'ifavailable',
});
